<template>
    <div v-if="isMounted">
        <div v-if="available_money < minimumAmountToReduceDues" class="vx-row">
            <div class="vx-col w-full">
                <vs-alert icon-pack="feather" icon="icon-info" color="warning" active="true">
                    <span>Monto mínimo para reducir adeudos: <strong>{{mxnFormat(minimumAmountToReduceDues,2)}}</strong></span>
                </vs-alert>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="DollarSignIcon"
                  :withIcon="false"
                  statisticTitle="Pagos al proveedor"
                  :statistic="costFormat(positive_surcharges, 2)" />
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4">
                <vx-tooltip text="Solo aplica para proyectos con periodo de entrega.">
                    <statistics-card-line
                    hideChart
                    class="mb-base"
                    icon="DollarSignIcon"
                    :withIcon="false"
                    textColor="#303f9f"
                    :statistic="costFormat(financed_interests, 2)"
                    statisticTitle="Intereses financiados iniciales" />
                </vx-tooltip>
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4">
                <vx-tooltip text="Solo aplica para proyectos con periodo de entrega.">
                    <statistics-card-line
                    hideChart
                    class="mb-base"
                    icon="DollarSignIcon"
                    :withIcon="false"
                    textColor="#43a047"
                    :statistic="costFormat(financed_interests_available, 2)"
                    statisticTitle="Intereses financiados disponibles" />
                </vx-tooltip>
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="DollarSignIcon"
                  :withIcon="false"
                  :statistic="costFormat(balance, 2)"
                  statisticTitle="Efectivo" />
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="DollarSignIcon"
                  textColor="#43a047"
                  :withIcon="false"
                  :statistic="costFormat(available_money, 2)"
                  statisticTitle="Dinero disponible" />
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4 mb-base">
                <statistics-card-line
                    hideChart
                    icon="DollarSignIcon"
                    :withIcon="false"
                    textColor="#f44336"
                    :statistic="costFormat(client_dues, 2)"
                    statisticTitle="Saldo vencido solicitante" />
                    <vs-button v-if="available_money >= minimumAmountToReduceDues && (client_dues != 0 || pending_initial_payments!=0) && !loading" color="success" class="w-full pulse-success" @click="simulacionPagarAdeudos()">Reducir</vs-button>
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4 mb-base">
                <statistics-card-line
                  hideChart
                  icon="DollarSignIcon"
                  :withIcon="false"
                  :statistic="costFormat(balance_to_due, 2)"
                  statisticTitle="Saldo insoluto (PID actual)" />
                  <vs-alert v-if="amortizationDues > 0" style="height:auto" class="text-center" color="danger">Sin amortización de adeudos: {{costFormat(balance_to_due-amortizationDues)}}</vs-alert>
            </div>
            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/4 mb-base">
                <statistics-card-line
                  hideChart
                  icon="DollarSignIcon"
                  :withIcon="false"
                  :statistic="costFormat(balance_to_due - amortizationDues + project_dues, 2)"
                  statisticTitle="Saldo Total (PID actual)" />
                  <vs-alert v-if="amortizationDues > 0" style="height:auto" class="text-center" color="success">Insoluto sin amortización de adeudos + Vencido</vs-alert>
            </div>
        </div>
        <div class="vx-row">
            <div v-if="user.user_id == 11838" class="vx-col w-full md:w-1/2 lg:w-1/4">
                <vx-card class="mb-5">
                    <div class="vx-col w-full">
                        <h4>Abono offline</h4>
                        <small>Este monto es considerado al recrear la ficha única de pago.</small>
                        <input type="text" class="form-control" v-model="funds" v-money="money">
                        <vs-button class="mt-5" v-if="!loading" color="success" @click="preguntarOffline">Abonar</vs-button>
                    </div>
                </vx-card>
            </div>
            <!-- <div class="vx-col w-full md:w-1/2 lg:w-1/4">
                <vx-card class="mb-5">
                    <h4 class="mb-3">Ficha única de pago</h4>
                    <div class="vx-col w-full">
                        <vs-alert icon-pack="feather" icon="icon-info" color="warning">
                            <span>Límite conekta: <strong>{{mxnFormat(max_monthly_cash_for_credit_payment_udis, 2)}}</strong></span>
                        </vs-alert>                        <label>Fecha de expiración</label> -->
                        <!-- <input type="date" :min="today_date" class="form-control" v-model="payment_date"> -->
                        <!-- <vs-button class="mt-5" v-if="!loading" color="danger" @click="preguntarFicha">Recrear</vs-button> -->
                        <!-- <vs-button v-if="!loading" color="success" class="ml-2" @click="popupSlipsActive=true">Fichas</vs-button> -->
                        <!-- <vs-button v-if="!loading" :disabled="!unique_slip" color="success" class="ml-2 mt-5" @click="downloadUniqueSlip">Ver</vs-button> -->
                    <!-- </div>
                </vx-card>
            </div> -->
            
            <!-- <div class="vx-col w-full lg:w-1/2">
                <vx-card class="mb-5">
                    <h4>Tarjetas del solicitante</h4>
                    <span class="bold">{{cards_url}}</span>
                    <div class="skinny row">
                        <div class="col-md-12 form-group" v-if="cards_url != ''">
                            Selecciona para realizar un abono
                        </div>
                    </div>
                    <div class="skinny row" v-if="user_id != ''">
                        <div class="col-md-12">
                            <cards :usuario="user_id" @selected="function(c){card = c}" :admin="true"></cards>
                        </div>
                    </div>
                    <div class="skinny row" v-if="card != ''">
                        <div class="col-md-12">
                            <vs-button v-if="!loading" class="mt-3" color="success" @click="preguntarTarjeta">Abonar</vs-button>
                        </div>
                    </div>
                </vx-card>
            </div> -->
        </div>
        <applicant-direct-billing :applicant-id="client_id"></applicant-direct-billing>

        <!-- MODAL FICHAS -->
        <vs-popup title="Fichas creadas vigentes" :active.sync="popupSlipsActive">
        <vs-table
            ref="slipsTable"
            stripe
            :data="references"
            noDataText="No hay datos disponibles"
        >
            <template slot="thead">
            <vs-th>Monto</vs-th>
            <vs-th>Fecha de expiración</vs-th>
            <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                <vs-td>{{moneyFormat(tr.amount, 2)}}</vs-td>
                <vs-td>{{tr.expiration_date}}</vs-td>
                <vs-td><a :href="$sanitizeUrl(tr.public_url)" target="_blank" rel="noopener"><em class="material-icons">open_in_new</em></a></vs-td>
            </vs-tr>
            </template>
        </vs-table>
        </vs-popup>
        <!--  -->

        <div class="modal fade" id="modal_tarjetas" tabindex="-1" role="dialog" aria-labelledby="modal_tarjetas_label" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modal_tarjetas_label">Abono por tarjeta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Confirmar abono de <strong>{{funds}}</strong> a la tarjeta <strong>{{card.card_number}}</strong>.<br>
                        <div v-if="final_due > 0">
                            Con este abono se tendrá un adeudo restante de <strong>${{formatPrice(final_due)}}</strong><br>
                            Si hay dudas con el adeudo restante o es necesario <strong>modificar recargos</strong> consultar el <a href="#" @click="showDues"><strong>desglose de adeudos</strong></a>.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="abonoTarjeta()" data-dismiss="modal">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal_fichas" tabindex="-1" role="dialog" aria-labelledby="modal_fichas_label" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modal_fichas_label">Recrear ficha</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        ¿Estás seguro de recrear la ficha única de pago para este solicitante? (Considera que el pdf generado tendrá los últimos cambios de las opciones de pago del solicitante)
                        <!-- Confirmar ficha de abono de <strong>{{funds}}</strong> para la fecha <strong>{{payment_date}}</strong>, (considera que la hora limite en la ficha será a las 11:30 PM y en caso de que sea dia inhábil se recorrerán los días necesarios).<br>
                        <div v-if="final_due > 0">
                            Con este abono se tendrá un adeudo restante de <strong>${{formatPrice(final_due)}}</strong><br>
                            Si hay dudas con el adeudo restante o es necesario <strong>modificar recargos</strong> consultar el <a href="#" @click="showDues"><strong>desglose de adeudos</strong></a>.
                        </div> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="abonoFicha" data-dismiss="modal">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal_offline" tabindex="-1" role="dialog" aria-labelledby="modal_offline_label" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modal_offline_label">Abono offline</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row">
                            <div class="col-md-12">
                                Confirmar abono offline  de <strong>{{funds}}</strong>.<br>                                
                            </div>
                        </div>
                        <div class="skinny row">
                            <div class="col-md-12">
                                <br>
                                Evidencia de pago
                            </div>
                        </div>
                        <div class="skinny row">
                            <br>
                            <div class="col-md-12">
                                <input type="file" id="evidence" name="evidence" ref="evidence" accept="image/png, image/jpeg, application/pdf">
                            </div>
                        </div>
                        <div class="skinny row">
                            <div class="col-md-12">
                                <br>
                                <input type="file" id="evidence2" name="evidence2" ref="evidence2" accept="image/png, image/jpeg, application/pdf">
                            </div>
                        </div>
                        <br>
                        <div v-if="final_due > 0">
                            Con este abono se tendrá un adeudo restante de <strong>${{formatPrice(final_due)}}</strong><br>
                            Si hay dudas con el adeudo restante o es necesario <strong>modificar recargos</strong> consultar el <a href="#" @click="showDues"><strong>desglose de adeudos</strong></a>.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="abonoOffline">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal_reduce" tabindex="-1" role="dialog" aria-labelledby="modal_reduce_label" aria-hidden="true">
            <div class="modal-dialog modal-reduce modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title" id="modal_reduce_label">Simulación de pago</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row">
                            <div class="col-md-12">
                                <resume-reduce :client_id="client_id" ref="resume_reduce" @updated="update"></resume-reduce>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let cards = require("./Cards").default
    import {formatPrice} from '../../../../components/admin/filters.js';
    import formatHelper from '@mixins/formatHelper';
    import {mapState} from "vuex";
    import {VMoney} from 'v-money';
    import ApplicantDirectBilling from "@views/admin/cobranza/components/ApplicantDirectBilling";

    const resume_reduce = require("./ResumeReduce").default
    export default {
        name: "PayFunds",
        mixins: [formatHelper],
        props:['project_id'],
        components: {
            'cards' :cards,
            'resume-reduce': resume_reduce,
            ApplicantDirectBilling
        },
        computed: {
            ...mapState('auth', ['user']),
        },
        async mounted(){
            this.isMounted = false;
            let today = new Date();
            today.setDate(today.getDate() + 1);
            this.payment_date = today.toISOString().slice(0, 10);
            await this.getInformation();
            $('#modal_reduce').on('hidden.bs.modal', this.resumeReduceOnHidden);
            this.isMounted = true;
        },
        data(){
            return {
                isMounted:false,
                balance: 0,
                amortizationDues:0,
                project_dues: 0,
                client_dues: 0,
                funds: 0,
                amount: 0,
                money: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '$',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                payment_date: '',
                card: '',
                client_id: '',
                user_id: '',
                loading: false,
                references:[],
                unique_slip:null,
                url: '',
                reference_type: 'bank_account',
                cards_url: '',
                available_money: 0,
                pending_initial_payments:0,
                minimumAmountToReduceDues: 0,
                max_monthly_cash_for_credit_payment_udis: 0,
                positive_surcharges: 0,
                financed_interests: 0,
                financed_interests_available: 0,
                balance_to_due :0,
                final_due: 0,
                today_date: new Date().toISOString().substring(0, 10),
                popupSlipsActive:false
            }
        },
        watch:{
            funds: function(){
                let s = this.funds.toString().replace('$', '');
                s = s.replace(',', '')
                s = s.replace(',', '')
                s = s.replace(',', '')
                this.amount = parseFloat(s)
                if(this.client_dues.toFixed(2) > (this.amount + this.available_money)){
                    this.final_due = this.client_dues.toFixed(2) - this.amount + this.available_money;
                    this.final_due = this.final_due.toFixed(2)
                }else{
                    this.final_due = 0;
                }
            }
        },
        methods:{
            formatPrice,
            async getInformation(context){
                await axios.get('/api/cobranza/adeudos/' + this.project_id).then(response => {
                    this.balance = response.data.balance
                    this.amortizationDues = response.data.amortization_dues;
                    this.project_dues = response.data.project_dues;
                    this.available_money = response.data.available_money
                    this.pending_initial_payments = response.data.pending_initial_payments
                    this.minimumAmountToReduceDues = response.data.minimumAmountToReduceDues
                    this.max_monthly_cash_for_credit_payment_udis = response.data.max_monthly_cash_for_credit_payment_udis;
                    this.positive_surcharges = response.data.positive_surcharges
                    this.financed_interests = response.data.financed_interests
                    this.financed_interests_available = response.data.financed_interests_available
                    this.balance_to_due = response.data.balance_to_due 
                    // si el solicitante tiene saldo negativo se suma a su saldo vencido para que se ponga al corriente
                    if(this.balance < 0){
                        this.client_dues = response.data.client_dues+Math.abs(this.balance);
                    }else{
                        this.client_dues = response.data.client_dues;
                    }  
                    this.client_id = response.data.client_id
                    this.user_id = response.data.user_id
                    this.references = response.data.references
                    this.unique_slip = response.data.unique_slip
                    this.url = response.data.url
                    this.cards_url = response.data.cards_url
                    if(this.balance < 0 && this.client_dues > this.available_money){
                        this.funds = (this.client_dues - this.available_money + Math.abs(this.balance)).toFixed(2);
                    }else{
                        if(this.client_dues > this.available_money){
                            this.funds = (this.client_dues - this.available_money).toFixed(2);
                        }
                    }
                }).catch(error => {
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                });
            },
            preguntarTarjeta(){
                $(document).ready(function(){
                    $('#modal_tarjetas').modal();
                });
            },
            preguntarFicha(){
                $(document).ready(function(){
                    $('#modal_fichas').modal();
                });
            },
            preguntarOffline(){
                $(document).ready(function(){
                    $('#modal_offline').modal();
                });
            },
            showDues(){
                 $(document).ready(function(){
                    $('.modal').modal('hide');
                });
                setTimeout(function(){
                    $('#modal_dues').modal();
                }, 1000)
            },
            simulacionPagarAdeudos() {
                $(document).ready(function(){
                    $('#modal_reduce').modal();
                });
                this.$refs.resume_reduce.simulate();
            },
            downloadUniqueSlip() {
                window.open(`${this.unique_slip.public_url}`, "_blank");
            },
            async confirmFunds(){
                // console.log(this.final_due)
                if(this.final_due > 0){
                    var error = false;
                    var message = '';
                    do{
                        message = 'Confirmo que el solicitante está de acuerdo con el adeudo restante de $' + this.formatPrice(this.final_due)+ ' \nConfirma con tu segundo factor de autenticación:';
                        if(error){
                            message = 'Segundo factor no valido\n' + message;
                        }
                        error = false;
                        var fa =  prompt(message, '');
                        if(fa !=  null && fa != ''){
                            try{
                                await axios.post('/api/auth/mfa/2fa/verify', {
                                    code: fa
                                })
                                return true
                            }catch(e){
                                if(e.response != undefined && e.response.data != undefined && e.response.data.code_error){
                                    error = true
                                }                                
                            }
                        }
                    }while (error);
                }else{
                    return true;
                }
                return false;
            },
            async abonoTarjeta(){
                if(this.card != ''){
                    var validate = await this.confirmFunds();
                    if(!validate){
                        return 0;
                    }
                    this.loading = true 
                    this.showLoading(true);
                    axios.post('/api/cobranza/abonar/tarjeta', {
                        card_id: this.card.id,
                        client_id: this.client_id,
                        amount: this.amount
                    }).then(response => {
                        this.loading = false;
                        this.showLoading(false);
                        //this.getInformation();
                        this.funds = 0;
                        this.$emit('updated', 1);
                        this.successNotif("Aviso", 'Abono exitoso', 4000);
                    }).catch(error => {
                        this.loading = false;
                        this.showLoading(false);
                        if(error.response.data.message != undefined){
                            this.errorNotif("Aviso", error.response.data.message, 4000);
                        }else{
                            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                        }
                    });
                }

            },
            async abonoFicha(){
                if(this.payment_date != ''){
                    // var validate = await this.confirmFunds();
                    // if(!validate){
                    //     return 0;
                    // }
                    this.loading = true;
                    this.showLoading(true);
                    axios.post('/api/cobranza/abonar/ficha', {
                        payment_date: this.payment_date,
                        client_id: this.client_id,
                        amount: this.amount
                    }).then(response => {
                        this.loading = false;
                        this.showLoading(false);
                        this.getInformation();
                        this.funds = 0;
                        this.successNotif('Aviso', 'Ficha creada y enviada.');
                        this.references.push({
                            url:response.data.url,
                            expiration_date:this.payment_date,
                            amount: this.amount,
                            public_url:response.data.public_url,
                        })
                        //window.open(response.data, "_blank", "height=800,width=1130,top=100,left=100")
                        //window.open(response.data.store, "_blank", "height=800,width=1130,top=100,left=100")
                    }).catch(error => {
                        this.loading = false;
                        this.showLoading(false);
                        if(error.response.data.message != undefined){
                            this.errorNotif("Aviso", error.response.data.message, 4000);
                        }else{
                            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                        }
                    });
                }
            },
            async abonoOffline(){
                var validate = await this.confirmFunds();
                if(!validate){
                    return 0;
                }
                var evidence = document.getElementById('evidence');
                var evidence2 = document.getElementById('evidence2');
                if(evidence.files.length == 0){
                    alert('Agrega una evidencia de pago.')
                    return 0;
                }
                $('#modal_offline').modal('hide')
                if(this.amount > 0){
                    this.showLoading(true);
                    if (!this.loading) {
                        this.loading = true;
                        var data = new FormData();
                        data.append("client_id", this.client_id);
                        data.append("amount", this.amount);
                        data.append("project_id", this.project_id);
                        data.append("evidence", evidence.files[0]);
                        if(evidence2.files.length > 0){
                            data.append("evidence2", evidence2.files[0]);
                        }
                        await axios.post('/api/cobranza/abonar/offline', data).then(response => {
                            //this.getInformation();
                            this.funds = 0;
                            this.$emit('updated', 1)
                            this.successNotif('Aviso', response.data.message);
                        }).catch(error => {
                            if(error.response.data.message != undefined){
                                this.errorNotif("Aviso", error.response.data.message, 4000);
                            }else{
                                this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                            }
                        });
                        this.showLoading(false);
                        this.loading = false;
                    }
                }
            },
            async update(){
                $('#modal_reduce').modal('hide');
                this.$emit('updated', 1)
            },
            resumeReduceOnHidden(){
                this.$refs.resume_reduce.reset();
            }
        }
    }
</script>
<style scoped>
    td > .material-icons{
        cursor:pointer;
    }
    .modal-reduce{
        min-width: 90%;
    }
</style>
